import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonWithSuitcase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 8A2.54 2.54 0 0 1 4 5.62v-1a2.53 2.53 0 0 1 3.443-2.452A2.55 2.55 0 0 1 9.08 4.52L9 5.62A2.54 2.54 0 0 1 6.5 8Zm0-4c-.39 0-.63.23-.63.52l.06 1a.52.52 0 0 0 1 0l.06-1A.52.52 0 0 0 6.55 4H6.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8 22a1 1 0 0 1-1-1v-5a1 1 0 0 1 .29-.71l.71-.71V11H5v3.58l.71.71A.999.999 0 0 1 6 16v5a1 1 0 1 1-2 0v-4.59l-.71-.71A1 1 0 0 1 3 15v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4a1 1 0 0 1-.29.7l-.71.71V21a1 1 0 0 1-1 1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.78 20.32c.34.341.762.58 1.22.697v.083a1 1 0 0 0 2 0h2a1 1 0 0 0 2 0v-.083a2.66 2.66 0 0 0 2-2.577v-3.68a2.66 2.66 0 0 0-2.66-2.66H17v-1h1a1 1 0 0 0 0-2h-4a1 1 0 1 0 0 2h1v1h-1.34A2.66 2.66 0 0 0 11 14.76v3.68c0 .705.28 1.382.78 1.88Zm6.56-1.22a.651.651 0 0 0 .66-.66v-3.68a.649.649 0 0 0-.66-.66h-4.68a.65.65 0 0 0-.66.66v3.68a.65.65 0 0 0 .66.66h4.68Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonWithSuitcase;
